import { Alert, Box, FormGroup, Radio, RadioGroup } from '@ksyos/design-system';
import type { HolterExaminationRequestBase } from '@common/validation/customControls/cardiology/holter/utils/utils';
import { Gender } from '@common/enums';
import { FormValidationMessage } from '@frontend/components/elements/FormValidationMessage';
import { useEditFormSectionInputFieldContext } from '@frontend/formEngine/editForm/useEditFormContext';
import { useProcessActivityEditContext } from '@frontend/utils';

export function HolterPatientGender() {
    const {
        data: { patient_geslacht },
        errors,
    } = useProcessActivityEditContext<HolterExaminationRequestBase>();
    const {
        field: { key, label },
        isRequired,
        onChange,
    } = useEditFormSectionInputFieldContext<HolterExaminationRequestBase>();

    return (
        <>
            <Alert appearance="info">
                <Box
                    alignItems="flex-start"
                    display="flex"
                    flexWrap="wrap"
                    justifyContent="space-between"
                    width="100%"
                >
                    <Alert.Text
                        as="p"
                        fontWeight="bold"
                        mb={2}
                        size="md"
                    >
                        Het geslacht van de patiënt is 'Onbekend'. De holter accepteert alleen man of vrouw als
                        geslacht. Maak een keuze.
                    </Alert.Text>
                </Box>
            </Alert>

            <FormGroup
                isRequired={isRequired}
                label={label}
            >
                <RadioGroup
                    layout="row"
                    onChange={(event) => onChange(event.target.value)}
                    value={patient_geslacht ?? ''}
                >
                    <Radio
                        label="Man"
                        value={Gender.male}
                    />
                    <Radio
                        label="Vrouw"
                        value={Gender.female}
                    />
                </RadioGroup>
                <FormValidationMessage error={errors.get(key)} />
            </FormGroup>
        </>
    );
}
